import ReactDOM from 'react-dom/client';
import './index.css';
import AppLoader from './AppLoader';

import { BrowserRouter} from 'react-router-dom'
import AuthProvider from './store/AuthProvider';
import NotificationProvider from './store/NotificationProvider';
import ModalProvider from './store/ModalProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <NotificationProvider>
      <AuthProvider>
        <ModalProvider>
          <AppLoader/>
        </ModalProvider>
      </AuthProvider>
    </NotificationProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


